import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import { ManageAccounts } from '@mui/icons-material';
import CustomSubmitButton from '../../../components/Forms/CustomSubmitButton';
import CustomTextField from '../../../components/Forms/CustomTextField';
import { useDispatch } from 'react-redux';
import { useUpdateORGLocationMutation } from '../../../api/profile/profileAPI';
import useRTK from '../../../hooks/useRTK';
import { setUserProfile } from '../../../states/features/profile/profileSlice';

// ################## VALIDATION ####################
// * -> location
const locationValidationSchema = Yup.object({
    location: Yup.string().required('Organization location is required field'),
});

// !############## MAIN FUNC ################
const UpdateLocation = ({ user, closeDialogy, refetchProfile }) => {
    // ################# CONST ##################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############### RTK #####################
    const [
        updateORGLocation,
        { isLoading, isSuccess, isError, error, data: updatedData },
    ] = useUpdateORGLocationMutation();

    // ############### useEffect ################
    // => RTK action
    const rtkActions = (data) => {
        closeDialogy();
        refetchProfile();
        dispatch(setUserProfile(data));
    };
    RTK.useRTKResponse(isSuccess, isError, error, updatedData, rtkActions);

    return (
        <>
            <Formik
                initialValues={{
                    location: user.location,
                }}
                validationSchema={locationValidationSchema}
                onSubmit={(payload) => {
                    updateORGLocation(payload);
                }}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent={'center'}>
                            <Grid item sm={12} xs={12} padding={1}>
                                <CustomTextField
                                    name="location"
                                    className="form-input"
                                    label={`${user.organization_type.name} location`}
                                    type="text"
                                />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <CustomSubmitButton
                                        startIcon={<ManageAccounts />}
                                        onClick={formik.handleSubmit}
                                        loading={isLoading}
                                    >
                                        Update location
                                    </CustomSubmitButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default UpdateLocation;
